export default __webpack_public_path__ + "afde64c60e37353205d665e3cd4e5ad5.png";